// Check if the application is running inside an IFrame
export const isIFrame = (): boolean => {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}
